import React from 'react';
import { DragDropContextProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import TouchBackend from 'react-dnd-touch-backend'
import { isMobile } from 'react-device-detect';

 class TaskDragDropContainer extends React.Component {
    render() {
        return (
            <DragDropContextProvider backend={isMobile ? TouchBackend : HTML5Backend }>
            {this.props.children}
        </DragDropContextProvider>
        )
    }
 }

export default TaskDragDropContainer;